import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@loot-os/ui/components/accordion";
import { Link } from "@tanstack/react-router";

import type { FaqContent, RichText } from "../../pages/home/content/faq.js";

/** The classic FAQ: the title beside an accordion of the questions. */
export function ClassicFaq({ title, entries }: FaqContent) {
  return (
    <section className="grid gap-4 lg:grid-cols-4 lg:gap-16">
      <h2 className="text-base leading-snug font-medium text-foreground lg:text-4xl lg:leading-none lg:tracking-tight">
        {title}
      </h2>
      <Accordion className="lg:col-span-3">
        {entries.map((entry) => (
          <AccordionItem key={entry.question} value={entry.question}>
            <AccordionTrigger>{entry.question}</AccordionTrigger>
            <AccordionContent>
              <ClassicRichText text={entry.answer} />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}

function ClassicRichText({ text }: { text: RichText }) {
  return text.map((segment) =>
    typeof segment === "string" ? (
      segment
    ) : (
      <Link key={segment.text} to={segment.link.to} className="underline">
        {segment.text}
      </Link>
    ),
  );
}
